import * as React from "react";
import { Spinner } from "@fluentui/react-components";
import type { SpinnerProps } from "@fluentui/react-components";
import './loader.css';

export const Default = (props: Partial<SpinnerProps>) => <Spinner {...props} />;